
<router-outlet />
@if (loader().show) {
  <anota-loader [title]="loader().title" />
}
